export function setCommonConfig(commonConfigArg) {
  if (commonConfigArg) {
    const commonConfig =
      typeof commonConfigArg === 'string'
        ? JSON.parse(decodeURIComponent(commonConfigArg))
        : commonConfigArg
    self.commonConfig = commonConfig
  }
}
